import { apiService } from './api.service';
import { ENDPOINTS } from '../config/api';
import { AdvisorResponse } from '../types';

interface AdvisorQuery {
  question: string;
  context?: any;
}

class AdvisorService {
  async queryAdvisor(query: AdvisorQuery): Promise<AdvisorResponse> {
    return apiService.post<AdvisorResponse>(ENDPOINTS.ADVISOR_QUERY, query);
  }

  async getRecommendations(): Promise<any> {
    return apiService.post(ENDPOINTS.ADVISOR_RECOMMENDATIONS);
  }
}

export const advisorService = new AdvisorService();
